import React from "react";
import RowMenu from "@/components/RowMenu";
import { useTheme, isModernTheme } from "@/lib/uiTheme";

/** Acțiunile unui rând de tabel. Aspect navy: butoane mici, unul lângă altul (ca înainte). Aspectele Fiord și Purple: un singur buton „⋮” care deschide lista.
 *  Aceleași acțiuni, aceleași drepturi (`disabled`/`title` vin din lock()), aceleași apeluri — se schimbă doar prezentarea.
 *  `items`: [{ label, onClick, icon?, primary?, btnDanger?, danger?, disabled?, title?, testid?, href? }]; `children`: elemente proprii (ex. „Șterge definitiv”). */
export default function RowActions({ items = [], children, testid, column = false }) {
  const theme = useTheme();
  const list = items.filter(Boolean);
  if (isModernTheme(theme)) return <RowMenu items={list} testid={testid}>{children}</RowMenu>;
  return (
    <div className={column ? "row-actions" : undefined} style={column ? undefined : { display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
      {list.map((it, i) => {
        const cls = "btn " + (it.primary ? "btn-primary" : it.btnDanger ? "btn-danger" : it.blue ? "btn-blue" : "btn-secondary");
        const props = { className: cls, style: { padding: "3px 10px", fontSize: 12 }, title: it.title, disabled: it.disabled, "aria-disabled": it["aria-disabled"], "data-testid": it.testid };
        return it.href
          ? <a key={i} {...props} href={it.href} target={it.target} rel={it.target ? "noreferrer" : undefined}>{it.label}</a>
          : <button key={i} type="button" {...props} onClick={it.onClick}>{it.label}</button>;
      })}
      {children}
    </div>
  );
}
